import React from 'react';
import { hashHistory } from 'react-router';
import MessageListAndToolsContainer from '@app/components/presentational/MessagingResponsive/MessageListAndTools/MessageListAndToolsContainer';
import PageView from './common/PageView';

const ConversationPageView: React.FC = () => {
  // Return to the previous page (all messages or home) after leave/archive.
  const handleClose = () => {
    hashHistory.goBack();
  };

  return (
    <PageView>
      <MessageListAndToolsContainer closeModal={handleClose} />
    </PageView>
  );
};

export default ConversationPageView;
